module.exports = __webpack_public_path__ + "606dea8b8e77aab081c484cb10f8e6bd.MP3";